import useScreenWidth from '../../hooks/useScreenWidth';
import './Gallery.css';
import {useEffect, useState} from "react";

const Gallery: React.FC = () => {
    const [isVisible, setVisible] = useState<boolean>(false);
    const screenWidth = useScreenWidth();

    useEffect(() => {
        setVisible(true);
    }, [])


    return (
        <div className="gallery">
            <div>
                <div className={`gallery_photos ${isVisible ? 'visible' : ''}`}>
                    <div className='gallery_photos1'>
                        <img className='gallery_photo' src={`${process.env.REACT_APP_IMG_URL}/gallery/galleryImg1S.jpg`} alt='MeArtComGallery' />
                        <img className='gallery_photo' src={`${process.env.REACT_APP_IMG_URL}/gallery/galleryImg7S.jpg`} alt='MeArtComGallery' />
                    </div>

                    <div className='gallery_photos2'>
                        <img className='gallery_photo' src={`${process.env.REACT_APP_IMG_URL}/gallery/galleryImg6S.jpg`} alt='MeArtComGallery' />
                    </div>

                    <div className='gallery_photos3'>
                        <img className='gallery_photo' src={`${process.env.REACT_APP_IMG_URL}/gallery/galleryImg5S.jpg`} alt='MeArtComGallery' />
                        <img className='gallery_photo' src={`${process.env.REACT_APP_IMG_URL}/gallery/galleryImg4S.jpg`} alt='MeArtComGallery' />
                    </div>

                    {screenWidth > 1024 && (
                        <div className='gallery_photos4'>
                            <img className='gallery_photo' src={`${process.env.REACT_APP_IMG_URL}/gallery/galleryImg3S.jpg`} alt='MeArtComGallery' />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Gallery;